const w = "/static", e = `${w}/library-images/main`, p = ["en-au"], g = (c) => p.includes(c), d = "en-au", a = {
  title: "Criminal law",
  description: "Addressing crime and sentencing.",
  image: `${e}/criminal-law.webp`
}, i = {
  title: "Employment law",
  description: "Fairness for employers and employees.",
  image: `${e}/employment-law.webp`
}, t = {
  title: "Commercial law",
  description: "Business transactions and agreements.",
  image: ""
}, n = {
  title: "Family law",
  description: "Separation, divorce, and settlements.",
  image: `${e}/family-law.webp`
}, l = {
  title: "Immigration law",
  description: "Visas, residency, and sponsorships.",
  image: `${e}/immigration-law.webp`
}, r = {
  title: "Litigation",
  description: "Matters involving the courts.",
  image: `${e}/litigation-law.webp`
}, s = {
  title: "Personal injury law",
  description: "Been injured? Help is available.",
  image: `${e}/personal-injury-law.webp`
}, o = {
  title: "Property law",
  description: "Settlements and property disputes.",
  image: `${e}/property-law.webp`
}, m = {
  title: "Estate and probate law",
  description: "Managing and distributing assets.",
  image: `${e}/estate-and-probate-law.webp`
}, y = {
  title: "Case study directory",
  footerTitle: "Browse all areas of law",
  description: "Example cases from all areas of law.",
  image: `${e}/directory.webp`
}, u = ["en-au", "en-gb"], b = {
  "en-au": [
    { ...n, title: "Family Law", link: "family-law" },
    { ...i, title: "Employment Law", link: "employment-law" },
    { ...o, title: "Property Law", link: "property-law" },
    { ...a, title: "Criminal Law", link: "criminal-law" },
    { ...m, title: "Wills, Estates & Probate", link: "estate-and-probate-law" },
    { ...l, title: "Immigration Law", link: "immigration-law" },
    { ...t, title: "Commercial Law", link: "commercial-law", image: `${e}/commercial-law-au.webp` },
    { ...r, title: "Civil Litigation", link: "litigation" },
    { ...s, title: "Personal Injury", link: "personal-injury-law" }
  ],
  "en-gb": [
    { ...t, image: `${e}/commercial-law-gb.webp` },
    a,
    i,
    m,
    n,
    l,
    r,
    s,
    o
  ],
  "en-us": [
    { ...t, image: `${e}/commercial-law-us.webp` },
    a,
    i,
    m,
    n,
    l,
    r,
    s,
    o
  ],
  "en-ie": [
    { ...t, image: `${e}/commercial-law-ie.webp` },
    a,
    i,
    m,
    n,
    l,
    r,
    s,
    o
  ],
  "en-ca": [
    { ...t, image: `${e}/commercial-law-ca.webp` },
    a,
    i,
    m,
    n,
    l,
    r,
    s,
    o
  ]
};
export {
  d as DEFAULT_LANGUAGE_CODE,
  e as IMAGE_BASE_PATH,
  w as STATIC_BASE_PATH,
  b as areasOfLawData,
  g as canLanguageUseAtticus,
  y as directoryBaseData,
  p as languagesWithAtticus,
  u as withDirectoryCountries
};
